export const CyResultList = {
  ButtonResultEntry: "ButtonResultEntry",
} as const;
